import React, { createContext, useContext, useState } from "react";


const ResponseContext = createContext({
  response: null,
  setResponse: () => { },
  clearResponse: () => { },
});

export const useResponse = () => useContext(ResponseContext);

export const ResponseContextProvider = ({ children }) => {
  const [response, setResponse] = useState(null);
  const clearResponse = () => {
    setResponse(null);
  };


  return (
    <ResponseContext.Provider value={{ response, setResponse, clearResponse }}>
      {children}
    </ResponseContext.Provider>
  );
};
